import { IProcessOrder } from '../interfaces/IProcessOrder';
import { OrderProcessingService } from '../services/order-processing/order-processing.service';

import { COMMON_PATHS, MOBILE_TYPE, ORDER_ID_TYPE } from './constants';
import { Utils } from './utils';

export interface AccessCodeSubmitConfig {
  type: string;
  flow: string;
  side: string;
  viewType: string;
  expireLoaded: boolean;
  enableDeliveryProvider: boolean;
  initTransactionByCode: boolean;
}

export function submitAccessCode(
  code: string,
  config: AccessCodeSubmitConfig,
  orderProcessingService: OrderProcessingService,
  utils: Utils
): void {
  const processedCode = isNaN(Number(code)) ? code.toLowerCase() : code;

  const isCoreType = [ORDER_ID_TYPE, MOBILE_TYPE].includes(config.type);
  const orderToProcess: IProcessOrder = {
    code: processedCode,
    type: config.type,
    flow: config.flow,
    side: config.side,
    expireLoaded: config.expireLoaded,
    frodoContext: config.viewType,
    initTransactionByCode: config.initTransactionByCode,
  };

  orderProcessingService.orderToProcess = orderToProcess;

  if (config.enableDeliveryProvider && isCoreType) {
    utils.redirect(`/${config.viewType}/${COMMON_PATHS.DELIVERY_PROVIDER}`);
  } else {
    orderProcessingService.processOrder(orderToProcess);
  }
}
